/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

//@module ProductLine
define('ProductLine.Common.Image'
,	[
		'SC.Configuration'

	,	'underscore'
	,	'Utils'
	]
,	function (
		Configuration

	,	_
	,	Utils
	)
{
	'use strict';

	//@class ProductLine.Common.Image
	return {

		//@method filterImages Given the tree-like object returned by the Search API containing the item's images and a group of options,
		// filters the item images
		// @param {Object} item_images_detail
		// @param {Array<String>} image_option_filters
		// @return {Object} The same input parameters filtered based on the current selection of the line/product taking into account the image option filters
		filterImages: function filterImages (item_images_detail, image_option_filters)
		{
			var self = this
			,	images_container = item_images_detail
			,	selected_option_filter;

			_.each(image_option_filters, function (image_filter)
			{
				selected_option_filter = self.get('options').findWhere({cartOptionId: image_filter});

				//if the option/dimension has a value set
				if (selected_option_filter && selected_option_filter.get('value') && selected_option_filter.get('value').label)
				{
					var label = selected_option_filter.get('value').label.toLowerCase();

					_.each(images_container, function(value, key)
					{
						if (key.toLowerCase() === label)
						{
							images_container = value;
						}
					});
				}
			});

			return images_container;
		}

		//@method getThumbnail Gets the thumbnail for the model based on the current selection
		//@return {ImageContainer}
	,	getThumbnail: function getThumbnail ()
		{
            var item = this.get('item');
            var tis = item;
            var objThumb = tis.get('_thumbnail');

            var objThumbNew = {
                url: tis.get('custitemitemimageurl1'),
                altimagetext: ''
            };

            if (tis.get('custitemitemimageurl1')) {
                if (objThumb && objThumb.altimagetext) {
                    objThumbNew.altimagetext = objThumb.altimagetext;
                }
                return objThumbNew;
            }
            // return the no image available stuff
            return objThumb;
		}
	};
});

